import { type InjectionKey } from 'vue'
export const flashKey = Symbol() as InjectionKey<(f: NMFlash) => void>
